import { Group, Button } from '@mantine/core';
import { useKianFlyoutStore } from '../../../stores/kianFlyout';
import { getPromptCatalog } from './kianPromptCatalog';

export interface KianQuickPromptsProps {
  entityType: string | null;
  /**
   * `toolbar` (default): horizontale Leiste mit Border-Bottom – für Headerbereich.
   * `inline`: ohne Border, größere Chips, zentriert – für Empty-State im Chat.
   */
  variant?: 'toolbar' | 'inline';
}

export function KianQuickPrompts({ entityType, variant = 'toolbar' }: KianQuickPromptsProps) {
  const injectInput = useKianFlyoutStore((s) => s.injectInput);
  const { quickPrompts } = getPromptCatalog(entityType);

  if (!quickPrompts.length) return null;

  const isInline = variant === 'inline';

  return (
    <Group
      gap={isInline ? 8 : 6}
      wrap="wrap"
      px="xs"
      py={isInline ? 8 : 6}
      justify={isInline ? 'center' : undefined}
      style={
        isInline
          ? { maxWidth: 360, marginInline: 'auto' }
          : { borderBottom: '1px solid var(--mantine-color-dark-6)' }
      }
    >
      {quickPrompts.map((text) => (
        <Button
          key={text}
          size={isInline ? 'xs' : 'compact-xs'}
          variant="light"
          color="cyberOrange"
          onClick={() => injectInput(text)}
        >
          {text}
        </Button>
      ))}
    </Group>
  );
}
